/**
 * Returns true if app is inside an iframe, false otherwise
 */
export const isIframed = (): boolean => {
  return window.top !== window.self;
};
